<template>
  <div class="min-h-full">
    <PageHeader title="Entity Classification" :breadcrumbs="[{ label: 'Beta' }]" />
    <div class="p-6">
      <Metric_Entity_Classification />
    </div>
  </div>
</template>

<script>
import Metric_Entity_Classification from '@/components/Portfolio_Management/Metric_Entity_Classification.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';

export default {
  name: 'EntityClassificationTab',
  components: {
    Metric_Entity_Classification,
    PageHeader,
  },
}
</script>
